import { render, staticRenderFns } from "./tuikuanGoods.vue?vue&type=template&id=2cf9fbdf&scoped=true&"
import script from "./tuikuanGoods.vue?vue&type=script&lang=js&"
export * from "./tuikuanGoods.vue?vue&type=script&lang=js&"
import style0 from "./tuikuanGoods.vue?vue&type=style&index=0&id=2cf9fbdf&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cf9fbdf",
  null
  
)

export default component.exports